import ChatIconWhite from '../../assets/icons/ChatIconWhite.svg?react';
import ChatIcon from '../../assets/icons/ChatIcon.svg?react';
import XButton from '../common/XButton';

const iconClasses = 'h-action-icon w-action-icon flex-none text-primary';

const ChatToggleButton = ({ isChatOpen, setIsChatOpen, variant = 'floating', className = '' }) => {
    const handleClick = () => setIsChatOpen(!isChatOpen);

    if (variant === 'action') {
        return (
            <XButton
                variant="actionOutline"
                className={className}
                onClick={handleClick}
            >
                <ChatIcon className={iconClasses} />
                <span>AI Chat</span>
            </XButton>
        );
    }

    return (
        <XButton
            variant="primary"
            className="chat-toggle-btn min-h-10 min-w-32 rounded-pill!"
            onClick={handleClick}
        >
            <ChatIconWhite />
            <span className="ml-2 font-semibold">AI Chat</span>
        </XButton>
    );
};

export default ChatToggleButton;
